<template>
	<div
		class="walter-mapview"
		:style="{ height: containerHeight }"
	>
		<button
			type="button"
			class="walter-mapview__placeholder"
			@click="open"
		>
			<span class="walter-mapview__placeholder-icon">🗺️</span>
			<span
				v-if="metricInfo"
				class="walter-mapview__placeholder-metric"
			>
				{{ metricInfo.metric || $t('walteriaMetric')
				}}<span v-if="metricInfo.unit"> ({{ metricInfo.unit }})</span>
			</span>
			<span class="walter-mapview__placeholder-cta">{{ $t('walteriaActivateMap') }}</span>
			<span
				v-if="metricInfo"
				class="walter-mapview__placeholder-scale"
			>
				<span
					class="walter-mapview__placeholder-bar"
					aria-hidden="true"
				></span>
				<span class="walter-mapview__placeholder-range">
					{{ formatLegendValue(metricInfo.min) }} – {{ formatLegendValue(metricInfo.max) }}
				</span>
			</span>
		</button>
	</div>
</template>

<script>
import { openMapViewer } from './mapViewerState'

export default {
	name: 'MapView',
	props: {
		geojson: { type: Object, required: true },
		// mantido por compatibilidade com AsyncMap; a altura do placeholder inline
		height: { type: String, default: '300px' },
	},
	computed: {
		containerHeight() {
			return this.height === '100vh' ? '300px' : this.height
		},
		metricInfo() {
			const feats = (this.geojson && this.geojson.features) || []
			const values = feats
				.filter(
					(f) => f.properties && f.properties.tipo === 'talhao' && f.properties._value != null,
				)
				.map((f) => Number(f.properties._value))
				.filter((v) => !isNaN(v))
			if (values.length === 0) return null
			const withMeta = feats.find(
				(f) => f.properties && (f.properties._metric || f.properties._unit),
			)
			return {
				metric: (withMeta && withMeta.properties._metric) || '',
				unit: (withMeta && withMeta.properties._unit) || '',
				min: Math.min(...values),
				max: Math.max(...values),
			}
		},
	},
	methods: {
		formatLegendValue(v) {
			return (Math.round(Number(v) * 10) / 10).toLocaleString('pt-BR')
		},
		open() {
			openMapViewer(this.geojson)
		},
	},
}
</script>

<style scoped>
.walter-mapview {
	position: relative;
	width: 100%;
	min-width: 450px;
	border-radius: 8px;
	overflow: hidden;
	border: 1px solid #ccd7df;
	background: #f1f5f8;
}
.walter-mapview__placeholder {
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 6px;
	border: none;
	cursor: pointer;
	background:
		radial-gradient(circle at 50% 40%, rgba(149, 187, 73, 0.12), transparent 60%),
		repeating-linear-gradient(45deg, #eef3f7, #eef3f7 12px, #e7eef4 12px, #e7eef4 24px);
	color: #01395e;
	font-family: 'Open Sans', sans-serif;
	transition: background 0.15s ease;
}
.walter-mapview__placeholder:hover {
	background:
		radial-gradient(circle at 50% 40%, rgba(149, 187, 73, 0.2), transparent 60%),
		repeating-linear-gradient(45deg, #e9f0f5, #e9f0f5 12px, #e1e9f0 12px, #e1e9f0 24px);
}
.walter-mapview__placeholder-icon {
	font-size: 28px;
	line-height: 1;
}
.walter-mapview__placeholder-metric {
	font-weight: 700;
	font-size: 14px;
}
.walter-mapview__placeholder-cta {
	font-size: 12px;
	color: #4a6b83;
}
.walter-mapview__placeholder-scale {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 3px;
	margin-top: 4px;
}
.walter-mapview__placeholder-bar {
	width: 140px;
	height: 8px;
	border-radius: 2px;
	background: linear-gradient(to right, #dc2626, #f97316, #eab308, #16a34a, #15803d);
}
.walter-mapview__placeholder-range {
	font-size: 11px;
	color: #4a6b83;
}
</style>
